'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatHeadGroupStyle = getChatHeadGroupStyle;

var _Constants = require('ui-addon-avatars/Constants');

/*
 * @param {object} options - sizing options
 * @param {object} options.mobile - boolean => is visitor on a mobile device
 * @param {object} options.border - number => the width of the border around the avatar
 *
 */
function getChatHeadGroupStyle(_ref) {
  var mobile = _ref.mobile,
      _ref$border = _ref.border,
      border = _ref$border === undefined ? 0 : _ref$border;

  if (mobile) {
    return {
      flex: '0 0 32px',
      height: _Constants.AVATAR_SIZES.sm + border * 2
    };
  }

  return {
    height: _Constants.AVATAR_SIZES.md + border * 2
  };
}